import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './rejectPendingApprovalProfileActions'

const initialState = {
  submitting: false,
  submitted: false
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case events.submitting.rejectProfile:
      newState.rejectProfile.submitting = true
      newState.rejectProfile.submitted = false
      return newState
    case events.submitted.rejectProfile:
      newState.rejectProfile.submitting = false
      newState.rejectProfile.submitted = true
      newState.edited = false
      return newState
  }
  return state
}
